import { vAutoAnimate } from '@formkit/auto-animate'
import { defineNuxtPlugin } from '#app'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('auto-animate', vAutoAnimate)
}) 